import { CardGrid } from 'src/components/AppScreen/AppLayout';
import Card from 'src/components/Card';
import { DesktopIcon, GroupIcon } from 'src/components/Icons/icons';
import { TextIcon } from 'src/components/Icons/TextIcon';
import { Section } from 'src/components/Section';
import { useTranslation } from 'react-i18next';

import { AdminList } from './components';
import { AdminAnalytics } from './Analytics';

export const Admin = () => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col space-y-10 ">
            <CardGrid>
                <Card
                    label={t('admin.dashboard.newOrganization')}
                    shape="circle"
                    to="/app/admin/organizations/new"
                >
                    <TextIcon SVG={GroupIcon} />
                </Card>
                <Card
                    label={t('admin.dashboard.newAdmin')}
                    shape="circle"
                    to="/app/admin/admins/new"
                >
                    <TextIcon SVG={DesktopIcon} />
                </Card>
            </CardGrid>
            <AdminAnalytics />
            <Section title={t('admin.dashboard.sectionTitle')}>
                <AdminList />
            </Section>
        </div>
    );
};
